import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { environment } from 'src/environments/environment';
import { CallAPI } from '../../constants/call-api-const';
import { LoaderService } from '../loader/loader.service';
import { AuthenticationService } from '../auth/authentication.service';
import { ToasterService } from '../toaster/toaster.service';
import { MatDialog } from '@angular/material/dialog';
import { CallConnectedComponent } from '../../shared-modules/components/call-connected/call-connected.component';

@Injectable({
  providedIn: 'root'
})
export class CallService {
  public call_connected:  Subject<any> = new Subject();
  connected_call = this.call_connected.asObservable();
  user_login_details: any
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private httpClient: HttpClient,
    private localStorageService: LocalStorageService,
    private httpClientService: HttpClientService,
    private _loaderService: LoaderService,
    private _authService: AuthenticationService,
    private _toaster: ToasterService,
    private dialog: MatDialog
  ) { 
    this.user_login_details = this._authService.getLoginUserDetails();
  }

  login(): Observable<any> {
    return this.httpClientService.post(`${CallAPI.login}`, {});
  }

  dialCall(payload: any, type?): Observable<any> {
    let url = `${CallAPI.dialLandline}`;

    if(type === 'mobile') {
      url = `${CallAPI.dialMob}`;
    }

    if(type === 'ladnline') {
      url = `${CallAPI.dialLandline}`;
    }

    if(type === 'international') {
      url = `${CallAPI.dialIInterv}`;
    }
    return this.httpClientService.post(`${url}`, payload);
  }

  logoutCall(token: any): Observable<any> {
    return this.httpClientService.get(`${CallAPI.logout}${token}`);
  }

  getRecording(app_id: any, pagination: any): Observable<any> {
    let payload = {
      "recording": ""
    }
    return this.httpClientService.get(`${CallAPI.recording}${app_id}&skip=${pagination.skip}&limit=${pagination.limit}`);
  }

  getCallLogs(pagination: any, applicationId?: string, startDate?: string, endDate?: string,
    currentStatus?: string,isCallScheduled?:string,isCallSuccessful?:string, scheduleCountry?:string,
    isCallBackReq?:string): Observable<any> {

    let url = `${CallAPI.callLogs}skip=${pagination.skip}&limit=${pagination.limit}`;

    if (applicationId) {
      url += `&applicationId=${applicationId}`;
    }

    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }
    
    if(currentStatus) {
      url += `&currentStatus=${currentStatus}`;
    }

    if(isCallScheduled) {
      url += `&isCallScheduled=${isCallScheduled}`;
    }

    if(isCallSuccessful) {
      url += `&isCallSuccessful=${isCallSuccessful}`;
    }

    if(scheduleCountry) {
      url += `&schduleCountry=${scheduleCountry}`;
    }

    if(isCallBackReq) {
      url += `&isCallBackReq=${isCallBackReq}`;
    }
    
    return this.httpClientService.get(url);
  }

  refreshRecording(payload) {
    return this.httpClientService.post(`${CallAPI.refresh}`, payload);
  }

  call(referenceId: any, number: any) {
    let payload = {
      referenceId: referenceId,
      callerSession: '1',
      callType: 'Outbound',
      extid: this.user_login_details?.extension,
      outto: number,
      autoanswer: "no"
    }

    this._loaderService.showLoader();
    this.dialCall(payload)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(result => {
      if (result && result?.data?.status === 'Success') { 
        this._loaderService.hideLoader();
        this.callConnectedSuccess();
      } else {
        this._toaster.showError('ERROR', 'Something went wrong');
      }
    }, (err) => {
      this._loaderService.hideLoader();
    })
  }

  callConnectedSuccess() {
    const dialogRef = this.dialog.open(CallConnectedComponent, {
        width: '30%',
        enterAnimationDuration: '300ms',
        exitAnimationDuration: '100ms',
        data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
        if (result) {
        }
    });
    dialogRef.afterOpened().subscribe((result) => {
        setTimeout(() => {
            dialogRef.close();
        }, 5000)
    })
}

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
